import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function KompanijskoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Kompanijsko pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Kompanijsko pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Kompanijsko pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 4
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Kompanijsko pravo je da studentima obezbijedi
                produbljena znanja iz oblasti Kompanijskog prava i osposobi ih
                za njihovu adekvatnu primjenu. Poseban naglasak će se staviti na
                kritički pristup postojećig zakonskih i uporednih rješenja. Cilj
                predmeta je takođe da se studenti osposobe za pravilnu primjenu
                i tumačenje zakonskih propisa prevashodno Zakona o privrednim
                društvima kao i to da analiziraju konkretno činjenično stanje
                koje se odnosi na pravni položaj i organizaciju konkretnog
                privrednog društva radi pravilne primjene pravnih pravila.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon uspješno savladanog predmeta Kompanijsko pravo studenti će
                steći adekvatno znanje za pravilnu primjenu propisa iz oblasti
                kompanijskog prava i njihovu kritičku analizu. Takođe nakon
                uspješno savladanog predmeta studenti će biti u mogućnosti da
                definišu i objasne pojedine oblike privrednih društava kao i da
                izdvoje i analiziraju njihove prednosti i nedostatke. Uz to
                studenti će biti u mogućnosti da utvrde i ocjene relevantne
                činjenice u postupku osnivanja, upravljanja i prestanka
                privrednog društva kao i u postupku donošenja odluka od strane
                organa tog društva kao i da pripremi osnivačka akta koja su
                potrebna za registraciju privrednog društva a koja su po
                osnovnim elementima i sadržini usklađena sa propisima i voljom
                osnivača.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong> Pojam kompanijskog prava,
                odnos kompanijskog i drugih grana prava, izvori kompanijskog
                prava, privredni i neprivredni subjekti, pojam privrednog
                društva, klasifikacija privrednih društava, konstitutivni
                elementi privrednog društva, pravni subjektivitet privrednih
                društava, sistem osnivanja privrednih društava, ortačko društvo,
                pojam kapitala društva, međusobni odnosi ortaka, prestanak
                društva, komanditno društvo, pojam osnivanja, odnos
                komplementara i komanditora, prestanak društva, društvo sa
                ograničenom odgovornošću, registracija, organi društva,
                akcionarsko društvo, registracija, organi društva, posebna
                društva, stečaj, stečajna načela, pokretanje stečajnog postupka,
                organi stečajnog postupka, okončanje stečajnog postupka.
                <br />
                <strong>Praktična nastava:</strong> Praktična nastava će se
                održavati u prostorijama fakulteta i van njih. Studenti će
                studijskim posjetama privrednim društvima imati priliku da se
                bolje i preciznije upoznaju sa radom i funkcionisanjem istih.
                Takođe, organizovaće se posjete Privrednom sudu Crne Gore kao i
                analiza sudske prakse i praktičnih primjera.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: Predavanja, vježbe,
                konsultacije, pismene provjere znanja (kolokvijumi),
                individualni rad studenata (seminarski i domaći radovi, referati
                i sl.) kao i grupno učestvovanje studenata na savladavanju
                određenih tematskih jedinica.
              </p>
              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 1V</td>
                    <td>Pojam kompanijskog prava</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 1V</td>
                    <td>Odnos kompanijskog prava i drugih grana prava</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 1V</td>
                    <td>Izvori kompanijskog prava</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 1V</td>
                    <td>Privredni i neprivredni subjekti</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 1V</td>
                    <td>
                      Pojam privrednog društva, klasifikacija privrednih
                      društava, konstitutivni elementi privrednog društva,
                      pravni subjektivitet privrednih društava + Praktična
                      nastava. Analiza praktičnih primjera.
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 1V</td>
                    <td>Sistem osnivanja privrednih društava</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 1V</td>
                    <td>
                      Ortačko društvo, pojam kapitala društva, međusobni odnosi
                      ortaka, prestanak društva
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 1V</td>
                    <td>
                      Komanditno društvo, pojam osnivanja, odnos komplementara i
                      komanditora, prestanak društva
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 1V</td>
                    <td>
                      Društvo sa ograničenom odgovornošću, registracija, organi
                      društva
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 1V</td>
                    <td>
                      Akcionarsko društvo, pojam, registracija, organi društva +
                      Praktična nastava. Posjeta privrednim društvima. Pisanje
                      statuta i drugih akata.
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 1V</td>
                    <td>
                      Posebna društva, povezivanje, promjena i prestanak društva
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 1V</td>
                    <td>Zastupnici i punomoćnici privrednog društva</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 1V</td>
                    <td>
                      Stečaj, stečajna načela, pokretanje stečajnog postupka,
                      organi stečajnog postupka, prethodni i glavni stečajni
                      postupak, okončanje stečajnog postupka + Praktična
                      nastava. Posjeta Privrednom sudu. Analiza sudske prakse.
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 3 č / 2.15h</td>
                            <td>Ukupno: 60 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 1.3h</td>
                            <td>Nastava + završni ispit: 45 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1 č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 4 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 11 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default KompanijskoPravo;
